export const environment = {
  production: true,
  apiUrl: 'https://api.obrame.com/api/',
  publicWebsiteUrl:'https://obrame.com',
  stripeApiKey: 'pk_live_51IkEF7CESuLdW9B8Hdq4Lr1oELT4qbnm6lQbL3obwlpUqDPJOOE9E70dKGnLpapu8w55WNNMxqG9c1NIzmN4kTY000URRPUkZd'
};
